import { Phone, MessageCircle, Star, Clock, Shield, CircleCheck as CheckCircle2 } from 'lucide-react';
import { FormProvider } from "@/integrations/forms/FormProvider";
import { Link } from "@/components/common/Link";
export default function RollerHero() {
  const formFooterItems = [{
    text: "100% Free Quote"
  }, {
    text: "Fast Response"
  }, {
    text: "Secure & Private"
  }];
  return <section style={{
    position: "relative",
    minHeight: "100vh",
    background: "#081438",
    overflow: "hidden",
    paddingTop: 100,
    paddingBottom: 80
  }} className="!bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/ecb5a9d3-0201-404c-b545-d75f7e3bbef0-3.png)]">
      {}
      <div style={{
      position: "absolute",
      inset: 0,
      backgroundImage: "linear-gradient(135deg, rgba(8,20,56,0.92) 0%, rgba(8,20,56,0.75) 50%, rgba(8,20,56,0.92) 100%), url('https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1920&q=70')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      zIndex: 0
    }} className="!bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/ecb5a9d3-0201-404c-b545-d75f7e3bbef0.webp)]" />

      {}
      <div style={{
      position: "absolute",
      inset: 0,
      backgroundImage: "linear-gradient(rgba(245,166,35,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(245,166,35,0.03) 1px, transparent 1px)",
      backgroundSize: "80px 80px",
      zIndex: 1,
      pointerEvents: "none"
    }} />

      {}
      <div style={{
      position: "absolute",
      top: "50%",
      left: 0,
      width: 60,
      height: 1,
      background: "linear-gradient(90deg, transparent, #F5A623)",
      zIndex: 2
    }} />

      <div style={{
      position: "relative",
      zIndex: 3,
      maxWidth: 1280,
      margin: "0 auto",
      padding: "0 24px",
      display: "grid",
      gridTemplateColumns: "1.1fr 0.9fr",
      gap: 60,
      alignItems: "center"
    }} className="roller-hero-grid">
        {}
        <div>
          {}
          <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 10,
          padding: "8px 16px",
          background: "rgba(245,166,35,0.1)",
          border: "1px solid rgba(245,166,35,0.25)",
          borderRadius: 100,
          marginBottom: 24
        }}>
            <span style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: "#F5A623",
            boxShadow: "0 0 12px #F5A623"
          }} />
            <span style={{
            fontFamily: "'Manrope', sans-serif",
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: 1.5,
            textTransform: "uppercase",
            color: "#F5A623"
          }}>
              Roller Door Specialists · Sydney Wide
            </span>
          </div>

          {}
          <h1 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontSize: "clamp(34px, 5vw, 58px)",
          fontWeight: 800,
          color: "#ffffff",
          lineHeight: 1.05,
          margin: "0 0 24px",
          letterSpacing: "-0.02em"
        }}>
            Roller Door Stuck,
            <br />
            Noisy or{" "}
            <span style={{
            background: "linear-gradient(135deg, #F5A623 0%, #D4A63A 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text"
          }}>
              Off the Tracks?
            </span>
          </h1>

          {}
          <p style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "clamp(16px, 1.5vw, 19px)",
          color: "rgba(255,255,255,0.75)",
          lineHeight: 1.6,
          margin: "0 0 32px",
          maxWidth: 540
        }}>
            We repair every roller door brand across Sydney — B&D, Gliderol,
            Steel-Line, ATA. Same-day callouts. Fixed-price quotes. 
            12-month workmanship warranty.
          </p>

          {}
          <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          marginBottom: 36
        }}>
            {[{
            icon: Clock,
            label: "Same-Day Service"
          }, {
            icon: Shield,
            label: "Licensed & Insured"
          }, {
            icon: Star,
            label: "5.0 Google Rated"
          }].map((pill, i) => {
            const Icon = pill.icon;
            return <div key={i} data-index={i} style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "8px 14px",
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: 8
            }}>
                  <Icon size={15} color="#F5A623" strokeWidth={2} />
                  <span style={{
                fontFamily: "'Manrope', sans-serif",
                fontSize: 13,
                fontWeight: 500,
                color: "rgba(255,255,255,0.9)"
              }}>
                    {pill.label}
                  </span>
                </div>;
          })}
          </div>

          {}
          <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 14
        }}>
            <Link to="tel:0485000933" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            padding: "16px 28px",
            background: "linear-gradient(135deg, #F5A623 0%, #D4A63A 100%)",
            color: "#081438",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: 16,
            fontWeight: 700,
            borderRadius: 10,
            textDecoration: "none",
            transition: "transform 0.2s, box-shadow 0.2s",
            boxShadow: "0 4px 20px rgba(245,166,35,0.3)"
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLElement).style.transform = "translateY(-2px)";
            (e.currentTarget as HTMLElement).style.boxShadow = "0 8px 30px rgba(245,166,35,0.5)";
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLElement).style.transform = "translateY(0)";
            (e.currentTarget as HTMLElement).style.boxShadow = "0 4px 20px rgba(245,166,35,0.3)";
          }}>
              <Phone size={18} strokeWidth={2.5} />
              Call 0485 000 933
            </Link>
            <Link to="https://wa.me/61485000933?text=Hi%20Gold%20Garage%20Door%2C%20I%20need%20roller%20door%20help." newTab style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            padding: "16px 28px",
            background: "#25D366",
            color: "#081438",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: 16,
            fontWeight: 700,
            borderRadius: 10,
            textDecoration: "none",
            transition: "transform 0.2s"
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLElement).style.transform = "translateY(-2px)";
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLElement).style.transform = "translateY(0)";
          }}>
              <MessageCircle size={18} strokeWidth={2.5} />
              WhatsApp Us
            </Link>
          </div>
        </div>

        {}
        <div id="contact-us" className="relative bg-white backdrop-blur-sm p-6 md:p-8 rounded-lg border border-[#F5A623]/40 shadow-2xl shadow-[#081438]/10 overflow-hidden scroll-mt-28">
          {}
          <div className="absolute inset-0 opacity-[0.015] bg-[url('data:image/svg+xml,%3Csvg%20width=%22100%22%20height=%22100%22%20xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cpath%20d=%22M0%200h100v100H0z%22%20fill=%22%23081438%22/%3E%3C/svg%3E')] pointer-events-none rounded-lg" />
          
          {}
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#F5A623] via-[#ffc142] to-[#F5A623]" />
          
          <div className="text-center mb-6">
            <h2 className="text-xl font-bold text-[#081438] mb-1.5">Get Your Free Quote</h2>
            <p className="text-[13.5px] text-[#555] font-medium">Fast response · No obligation · No hidden fees</p>
            <div className="h-px bg-gradient-to-r from-transparent via-[#F5A623]/20 to-transparent my-4" />
          </div>

          <div className="space-y-4">
            <div className="w-full">
              <FormProvider formId="hero_quote_form" sectionName="Hero Section" defaultValues={{
              name: "",
              phone: "",
              suburb: "",
              service: ""
            }} successMessage="Thank you! Your quote request has been sent.">
                <form className="space-y-3">
                  <div>
                    <input type="text" placeholder="Your Name" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F5A623] text-sm" />
                  </div>
                  <div>
                    <input type="tel" placeholder="Phone Number" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F5A623] text-sm" />
                  </div>
                  <div>
                    <input type="text" placeholder="Suburb" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F5A623] text-sm" />
                  </div>
                  <div>
                    <select className="w-full px-3 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F5A623] text-sm bg-white">
                      <option value="">Select Service</option>
                      <option value="repair">Roller Door Repair</option>
                      <option value="installation">Installation</option>
                      <option value="maintenance">Maintenance</option>
                    </select>
                  </div>
                  <button type="submit" className="w-full bg-gradient-to-r from-[#F5A623] to-[#D4A63A] text-[#081438] font-semibold py-2.5 rounded-lg hover:shadow-lg transition-shadow text-sm">
                    Get Free Quote
                  </button>
                </form>
              </FormProvider>
            </div>
          </div>

          <div className="mt-6 pt-4 border-t border-black/5 flex justify-center gap-5">
            {formFooterItems.map((item, i) => {
            const icons = ["💰", "⚡", "🔒"];
            return <div key={i} data-index={i} className="flex items-center gap-1.5">
                  <span className="text-lg">{icons[i]}</span>
                  <span className="text-[12px] font-semibold text-[#333]">{item.text}</span>
                </div>;
          })}
          </div>
        </div>
      </div>

      {}
      <style>{`
        @media (max-width: 960px) {
          .roller-hero-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
        }
      `}</style>
    </section>;
}